export default [{
		id: 1,
		title: '成都经开区第二届农民工技能大赛养老护理员赛项在我校顺利举行',
		info: '2023年3月14日-15日，由成都经开区人力资源和社会保障局主办，我校承办的成都经开区第二届农民工技能大赛养老护理员赛项在我校顺利举行。来自经开区的30名养老护理骨干人员参加了此次比赛。',
		yymm: '2023.03',
		dd: '15',
		createTime: '2023-03-15'
	},
	{
		id: 2,
		title: '智慧健康养老服务与管理专业群开展专业群调研',
		info: '2023年3月13日，四川城市职业学院校长助理、医学与健康学院院长侯志春教授，康养系主任刘燕老师，对外合作部李晶老师一行三人赴四川川妹子家政有限公司开展了智慧健康养老服务与管理专业群调研。',
		yymm: '2023.03',
		dd: '15',
		createTime: '2023-03-15'
	},
	{
		id: 3,
		title: '眉山机电职业技术学院来我校考察交流 智慧健康养老服务与管理专业建设',
		info: '近日，为了提升智慧健康养老服务与管理专业办学质量，促进专业的校校交流，眉山机电职业技术学院校长杨泽民、教务主任王丹、教务处科长吴梦操、专业教师黄欣杰一行4人来到我校眉山校区考察交流，我校校长助理、医学与健康学院院长侯志春，副院长林琳热情接待并开展交流。',
		yymm: '2023.03',
		dd: '17',
		createTime: '2023-03-17'
	},
	{
		id: 4,
		title: '访企拓岗—智慧健康养老服务与管理专业深入企业开展调研',
		info: '为深入了解养老企业用人需求，厘清专业建设方向，明确人才培养目标，2023年3月17日，我校智慧健康养老服务与管理专业深入成都市川投舒适之家·颐康养老中心开展了调研活动。校长助理、医学与健康学院侯志春教授，康养系主任刘燕，专业教师曾莉共赴企业调研。',
		yymm: '2023.03',
		dd: '20',
		createTime: '2023-03-20'
	},
	{
		id: 5,
		title: '智慧健康养老服务与管理专业开展专业调研活动',
		info: '2023年3月17日，四川城市职业学院校长助理、医学与健康学院侯志春教授，康养系主任刘燕老师，专业教师曾莉老师赴成都锦江区兴城康养·美邸舒养之家海桐苑开展了智慧健康养老服务与管理专业的调研活动。',
		yymm: '2023.03',
		dd: '20',
		createTime: '2023-03-20'
	},
	{
		id: 6,
		title: '我校参加重庆市养老服务业发展暨西部健康养老职业教育集团 成立大会',
		info: '2023年3月18日，重庆市养老服务业发展暨西部健康养老职业教育集团成立大会在重庆召开，我校当选为西部健康养老职教集团常务理事单位，校长助理、医学与健康学院院长侯志春，专业负责人曾莉老师参加了此次大会。',
		yymm: '2023.03',
		dd: '27',
		createTime: '2023-03-27'
	},
	{
		id: 7,
		title: '智慧健康养老服务与管理专业单招技能测试',
		info: '又是一年“春季高考”——单独招生考试进行时，来自全国各地的考生早在考试前一天就来到了学校，通过参观校园提前熟悉考场，观看专业展示提升专业技能，大家都做了充分的准备迎接第二天的考试。',
		yymm: '2023.03',
		dd: '31',
		createTime: '2023-03-31'
	},
	{
		id: 8,
		title: '我校成为四川省养老服务发展协会养老人才培养专业委员会成员',
		info: '2023年4月25日，四川省养老服务发展协会养老人才培养专业委员会的成立大会在四川省养老服务中心举办，我校作为专委会成员参加了成立大会正在上传...。',
		yymm: '2023.04',
		dd: '26',
		createTime: '2023-04-26'
	},
	{
		id: 9,
		title: '我校参加四川省养老服务业协会换届大会',
		info: '2023年5月23日上午，四川省养老服务业协会换届大会在协会所在地富力中心A座举行。我校作为协会副会长单位受邀参加。校长助理、医学与健康学院院长侯志春、专业负责人曾莉代表学校参加了换届大会。',
		yymm: '2023.05',
		dd: '25',
		createTime: '2023-05-25'
	},
	{
		id: 10,
		title: '医学与健康学院参加四川省养老服务业协会换届大会',
		info: '近日，四川省养老服务业协会换届大会举行。我校作为协会副会长单位受邀参加。校长助理、医学与健康学院院长侯志春及专业负责人曾莉代表学校参加。',
		yymm: '2023.05',
		dd: '29',
		createTime: '2023-05-29'
	},
	{
		id: 11,
		title: '成渝地区双城经济圈智慧健康养老职教集团产教融合论坛举行',
		info: '成渝地区双城经济圈智慧健康养老职教集团产教融合论坛在四川城市职业学院举行，来自成渝两地30余家职业院校、行业组织和养老机构参加了论坛。论坛由成渝地区双城经济圈智慧健康养老职教集团主办，四川城市职业学院、重庆城市管理职业学院共同承办。',
		yymm: '2023.05',
		dd: '29',
		createTime: '2023-05-29'
	},
	{
		id: 12,
		title: '搭平台促交流 推动成渝地区养老产业高质量发展',
		info: '搭平台促交流 推动成渝地区养老产业高质量发展',
		yymm: '2023.05',
		dd: '30',
		createTime: '2023-05-30'
	},
	{
		id: 13,
		title: '2021级智慧健康养老服务与管理专业开展岗位实习动员说明会',
		info: '岗位实习是人才培养方案中重要的一环，它是同学们第一次踏上岗位亲身历练，是第一次面对现实社会，是真正将课上所学所练运用到实际工作中的过程。',
		yymm: '2023.06',
		dd: '19',
		createTime: '2023-06-19'
	},
	{
		id: 14,
		title: '2021级智慧健康养老及家政专业召开岗位实习双选会',
		info: '为提高学生的专业技能，将学校所学理论、实操知识与岗位工作有效衔接，2021级智慧健康养老与家政专业在结束大二阶段的课程后，将开启专业岗位实习。',
		yymm: '2023.06',
		dd: '19',
		createTime: '2023-06-19'
	},
	{
		id: 15,
		title: '2021级智慧健康养老服务与管理专业岗位实习安全教育',
		info: '为使学生明确岗位实习过程中安全的重要性，提高安全意识、提升防骗入坑等安全认识，专业教师吕雪老师针对2021级智慧健康养老服务与管理专业的同学开展了一次岗位实习前的安全教育。',
		yymm: '2023.06',
		dd: '19',
		createTime: '2023-06-19'
	}
]